var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, computed } from "mobx";
export class NotificationPreviewDialogModel {
    constructor() {
        this.currentTab = "EMAIL";
        this.previewData = null;
        this.isLoading = false;
        this.setCurrentTab = (tab) => {
            this.currentTab = tab;
        };
        this.setPreviewData = (data) => {
            this.previewData = data;
            if (data) {
                this.currentTab = "EMAIL";
            }
        };
        this.setLoading = (loading) => {
            this.isLoading = loading;
        };
        this.clear = () => {
            this.previewData = null;
            this.currentTab = "EMAIL";
            this.isLoading = false;
        };
    }
    get tabsToShow() {
        return [
            { value: "EMAIL", label: "Email" },
            { value: "SMS", label: "SMS" },
        ];
    }
    get hasPreviewData() {
        return this.previewData !== null;
    }
    get emailContent() {
        var _a;
        return (_a = this.previewData) === null || _a === void 0 ? void 0 : _a.emailContent;
    }
    get smsContent() {
        var _a;
        return (_a = this.previewData) === null || _a === void 0 ? void 0 : _a.smsContent;
    }
}
__decorate([
    observable
], NotificationPreviewDialogModel.prototype, "currentTab", void 0);
__decorate([
    observable
], NotificationPreviewDialogModel.prototype, "previewData", void 0);
__decorate([
    observable
], NotificationPreviewDialogModel.prototype, "isLoading", void 0);
__decorate([
    computed
], NotificationPreviewDialogModel.prototype, "tabsToShow", null);
__decorate([
    computed
], NotificationPreviewDialogModel.prototype, "hasPreviewData", null);
__decorate([
    computed
], NotificationPreviewDialogModel.prototype, "emailContent", null);
__decorate([
    computed
], NotificationPreviewDialogModel.prototype, "smsContent", null);
